import React from 'react'
import styles from './PageHeader.module.css'

/* The V4 page header, one for every screen: a 64px bar on the surface with
   the title (Caprasimo 24px) on the left and the screen's actions on the
   right, then, when the screen has them, a bar of underline tabs (PairTabs or
   the screen's own). Below both the screen's body sits on --dp-panel with
   16px 24px of padding (PageBody). */
export function PageHeader({
  title,
  actions,
  tabs,
  children,
  titleWidth,
}: {
  title: React.ReactNode
  actions?: React.ReactNode
  tabs?: React.ReactNode
  // Anything that sits between the title and the actions (V4 puts a few
  // screens' period pickers or status pills there).
  children?: React.ReactNode
  // V4 fixes the title's width on screens where the bar's middle lines up
  // with the body below; most screens leave it to the text.
  titleWidth?: string
}) {
  return (
    <>
      <header className={styles.bar}>
        <h1 className={styles.title} style={titleWidth ? { width: titleWidth } : undefined}>
          {title}
        </h1>
        {children}
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
      {tabs}
    </>
  )
}

/* The screen's body under the header: --dp-panel, 16px 24px. */
export function PageBody({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={`${styles.body} ${className || ''}`}>{children}</div>
}

/* The bar the underline tabs sit in (PairTabs renders one; a screen with its
   own tab set can use this directly). */
export function TabBar({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <nav className={styles.tabBar} aria-label={label}>
      {children}
    </nav>
  )
}

export { styles as headerStyles }
